import { render, staticRenderFns } from "./PageEditorContentNavContentArea.vue?vue&type=template&id=265704e5&scoped=true"
import script from "./PageEditorContentNavContentArea.vue?vue&type=script&lang=js"
export * from "./PageEditorContentNavContentArea.vue?vue&type=script&lang=js"
import style0 from "./PageEditorContentNavContentArea.vue?vue&type=style&index=0&id=265704e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265704e5",
  null
  
)

export default component.exports